import patentInput from './saveInputs/patentInput';

export default (patent) => `
    savePatentLostHistory (history: {
        ${patentInput(patent)}
    }) {
        id
    }
`;
